var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"head"}},[_c('h1',[_vm._v("Pin "+_vm._s(_vm.name.slice(-3)))]),_c('p',[_c('img',{attrs:{"src":_vm.image,"height":"21","width":"33"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }